module.exports = __webpack_public_path__ + "fonts/Raleway-Medium.2551d6fd.ttf";